import { GROUPS, REDIRECT_URLS } from "../../globalConstants";
import { inject } from "../../lib/itn-ui-kit/services/service-container";
export default class LandingService {
  currentUserService = inject("current-user-service");

  get PriorityAccessibleRoute() {
    //returns string route of first match which right now is finance
    const accessibleRoutes = this.currentUserService.accessibleRoutes;

    if (accessibleRoutes.includes(GROUPS.FINANCE)) {
      return REDIRECT_URLS.FINANCE;
    } else if (accessibleRoutes.includes(GROUPS.MEDICAL_RECORDS)) {
      return REDIRECT_URLS.MEDICAL_RECORDS;
    } else if (accessibleRoutes.includes(GROUPS.MCC)) {
      return REDIRECT_URLS.MCC;
    } else {
      return REDIRECT_URLS.DASHBOARD;
    }
  }

  get AllAccessibleRoutes() {
    //returns list of all accessible routes
    let routeArr = [];

    if (
      this.currentUserService.accessibleRoutes &&
      this.currentUserService.accessibleRoutes.length > 0
    ) {
      routeArr = this.currentUserService.accessibleRoutes.map((route) => {
        if (route === GROUPS.FINANCE)
          return { name: route, url: REDIRECT_URLS.FINANCE };
        if (route === GROUPS.MEDICAL_RECORDS)
          return { name: route, url: REDIRECT_URLS.MEDICAL_RECORDS };
        if (route === GROUPS.MCC)
          return { name: route, url: REDIRECT_URLS.MCC };
      });
    } else {
      //if you have no special routes show the main dashboard
      routeArr.push({ name: "", url: REDIRECT_URLS.DASHBOARD });
    }

    return routeArr;
  }
}
